<template>
  <TWorkPackage
    :key="`workpackage${workpackage.id}`"
    :workpackage_count="waggon.tworkpackages.length"
    :workpackage="workpackage"
    :easter_egg="easter_egg"
    :color="getStatisticSettings.filter &&
            (
            (getStatisticSettings.colors.length !== 0 &&
            !getStatisticSettings.colors.includes(workpackage.color)) ||
            (getStatisticSettings.icons.length !== 0 &&
            !getStatisticSettings.icons.includes(workpackage.icon)) ||
            (getStatisticSettings.status.length !== 0 &&
            !getStatisticSettings.status.includes(workpackage.status)) ||
            (getStatisticSettings.trains.length !== 0 &&
            !getStatisticSettings.trains.includes(train.id))

          ) ||
          (isShowOwnWps &&
          getOwnTWorkPackages(project_id).length !== 0 &&
          !getOwnTWorkPackages(project_id).includes(workpackage.id))
          ?
          'grey darken-2':false"
    @click.native="handleTWorkpackageClick(
      train,
      waggon,
      workpackage,
      train.id,
      taktarea.id,
      waggon.id,
      workpackage.id,
      $event
      )"
    >
    <template #workpackage="workpackageslot">
      <transition
        name="zoom"
        >
        <StandardBadge
          class="cursor-pointer"
          v-if="!(hover_waggon && isEditMode) &&
                workpackageslot.workpackage.status &&
                (workpackageslot.workpackage.status !== 'none' || workpackageslot.workpackage.stop_status !== 'none') &&
                isShowStatusBadges &&
                workpackage.status !== 'stop'
                "
          :key="`workpackagebadge${workpackage.id}`"
          :icon="workpackage.stop_status !== 'none'?(workpackage.stop_status === 'ai_stop'?'ai_stop':'exclamation-triangle-negative'):getStatusArray.find(status => status.name === workpackageslot.workpackage.status).icon"
          color="white"
          :content_color="workpackageslot.workpackage.stop_status !== 'none' ? 'red':'black'"
          @click.native="$route.name === 'ProjectTaktPlan'?$emit('openWaggonInfo', $event):''"
        />
      </transition>
      <StandardBadgeMini
        v-if="workpackageslot.workpackage.status &&
              workpackageslot.workpackage.status !== 'none' &&
              !isShowStatusBadges"
        />
    </template>
  </TWorkPackage>
</template>
<script>
  import { mapGetters, mapActions } from 'vuex';

  import TWorkPackage from '@/components/ProjectTaktPlan/Workpackage.component.vue';
  import StandardBadge from '@/components/StandardComponents/StandardBadge.component.vue'
  import StandardBadgeMini from '@/components/StandardComponents/StandardBadgeMini.component.vue'

  export default {
    props: [
      'project_id',
      'workpackage',
      'train',
      'taktarea',
      'waggon',
      'easter_egg',
      'new_milestone',
      'milestone_selection',
      'snackbar',
      'hover_waggon',
    ],
    components: {
      TWorkPackage,
      StandardBadge,
      StandardBadgeMini,
    },
    data: () => ({
    }),
    // updated() {
    //   console.log('tpworkpackage updated');
    // },
    computed: {
      ...mapGetters('ProjectStatistics', [
        'getStatisticSettings',
      ]),
      ...mapGetters('View', [
          'isShowOwnWps',
      ]),
      ...mapGetters('Project', [
        'getOwnTWorkPackages',
        'getStatusArray',
        'isEditMode',
        'isShowStatusBadges',
      ]),
      ...mapGetters('ProjectMilestone', [
        'getNewMilestone',
        'getMileStoneLinkType',
      ]),
      ...mapGetters('SnackBar', [
        'getAffectedTargets'
      ]),
    },
    methods: {
      ...mapActions('ProjectMilestone', [
        'updateMilestoneBulk',
        'updateNewMilestoneBulk',
        'resetNewMilestone',
        'editMilestoneSelection',
        'editNewMilestoneSelection',
      ]),
      handleTWorkpackageClick(train, waggon, work_package, train_id, taktarea_id, waggon_id, workpackage_id, evt) {
        if (this.$route.name === 'TrainMilestonesAdd' &&
          this.getNewMilestone(this.project_id).milestone.linkType === 'selection') {
          this.editNewMilestoneSelection({
            project_id: this.project_id,
            prop: 'tworkpackages',
            value: work_package,
            train: train,
          });
        }
        else if (this.$route.name === 'TrainMilestonesAdd' &&
          this.getNewMilestone(this.project_id).milestone.linkType === 'type') {
          this.updateNewMilestoneBulk([
            {prop: 'wp_color_active', value: true},
            {prop: 'wp_color', value: work_package.color},
            {prop: 'wp_token_active', value: true},
            {prop: 'wp_token', value: work_package.token},
            {prop: 'wp_icon_active', value: true},
            {prop: 'wp_icon', value: work_package.icon},
            {prop: 'wp_name_active', value: true},
            {prop: 'wp_name', value: work_package.name},
          ]);
        }
        else if (this.$route.name === 'TrainMilestonesEdit' &&
            this.getMileStoneLinkType({
              project_id: this.project_id,
              milestone_id: this.$route.params.milestone_id
            }) === 'selection') {
          this.editMilestoneSelection({
            project_id: this.project_id,
            milestone_id: this.$route.params.milestone_id,
            prop: 'tworkpackages',
            value: work_package,
            train: train,
          });
        }
        else if (this.$route.name === 'TrainMilestonesEdit' &&
            this.getMileStoneLinkType({
              project_id: this.project_id,
              milestone_id: this.$route.params.milestone_id
            }) === 'type') {
          this.updateMilestoneBulk({
            project_id: this.project_id,
            milestone_id: this.$route.params.milestone_id,
            type: 'milestones',
            data: [
              {prop: 'wp_color_active', value: true},
              {prop: 'wp_color', value: work_package.color},
              {prop: 'wp_token_active', value: true},
              {prop: 'wp_token', value: work_package.token},
              {prop: 'wp_icon_active', value: true},
              {prop: 'wp_icon', value: work_package.icon},
              {prop: 'wp_name_active', value: true},
              {prop: 'wp_name', value: work_package.name},
            ]
          });
        }
        else {
          this.$emit('openWaggonInfo', evt)
        }
      }
    }
  }
</script>
<style>
  .class {

  }
</style>
